import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SanitizerPipe } from './sanitizer.pipe';

@NgModule({
  imports: [CommonModule, SanitizerPipe],
  exports: [SanitizerPipe],
  providers: [SanitizerPipe],
})
export class SanitizerModule {}
